import { useCallback } from 'react';
import usePostJobPostImportRequest from '../../../api/usePostJobPostImportRequest';

type JobPostImportRequestResponse = {
  id: number;
  encrypt_id: string;
  status: 'draft' | 'processing' | 'failed' | 'completed';
  file_type: string;
  created_at: string;
  updated_at: string;
};

// インポートリクエストの作成のみを行うフック
// 取得・ポーリングは別のフック（useFetchJobPostImportRequest）で行う
export default function useCreateJobPostImportRequest() {
  const { mutateAsync: postJobPostImportRequest, isPending } = usePostJobPostImportRequest();

  const create = useCallback(
    async (file: File): Promise<JobPostImportRequestResponse> => {
      return (await postJobPostImportRequest({ file })) as JobPostImportRequestResponse;
    },
    [postJobPostImportRequest]
  );

  return {
    create,
    isPending,
  };
}
